import {isObjectsSame} from "./common";
import {fromJS} from "immutable";

export const setCardActive = (state, payload) => {
  const menuCards = state.toJS();
  let i = 0;
  for (i; i < menuCards.length; ++i) {
    const cardIndex = menuCards[i].findIndex((card) => {
      return isObjectsSame(card, payload);
    });
    if (cardIndex !== -1) {
      menuCards[i][cardIndex].active = !payload.active;
      break;
    }
  }

  return fromJS(menuCards);
};

export const showHint = (state, {type}) => {
  const hints = state.toJS().hints;
  hints.find(hint => hint.type === type).visible = true;

  return fromJS({
    hints
  });
};